import React from "react";
import { Redirect, Link } from "react-router-dom";
import { useStoreState, useStoreActions } from "easy-peasy";

import useDocumentTitle from "../hooks/useDocumentTitle";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Input,
} from "reactstrap";
import { Form, Formik } from "formik";
import FormikInput from "./FormikInput";

const Login = ({ login, ...props }) => {
  const loggedIn = useStoreState((state) => state.auth.loggedIn);
  const addToast = useStoreActions((actions) => actions.toasts.addToast);
  const email = props.location.state ? props.location.state.email : "";
  const initialValues = { password: "", username: email };
  console.log(props.location);
  useDocumentTitle("Login");

  const handleLogin = async (values) => {
    await login(values).then(
      (res) => {},
      (err) => {
        addToast({
          color: "danger",
          message: "Invalid Username or Password",
        });
      }
    );
  };

  return (
    <>
      {loggedIn ? (
        <Redirect to="/home" />
      ) : (
        <Row className="h-100">
          <Col xs={12} lg={4} className="mx-auto">
            <Card style={{ marginTop: "20%" }}>
              <CardHeader className="theme-blue"></CardHeader>
              <CardBody>
                <Formik
                  initialValues={initialValues}
                  onSubmit={async (values) => handleLogin(values)}
                >
                  {({ isSubmitting }) => (
                    <Form className="text-center">
                      <h2>Login</h2>
                      <FormikInput
                        type="email"
                        name="username"
                        hideLabel
                        placeholder="Email Address"
                        hideValidation
                        as={Input}
                      />
                      <FormikInput
                        type="password"
                        name="password"
                        hideLabel
                        placeholder="Password"
                        hideValidation
                        as={Input}
                      />
                      <Button
                        type="submit"
                        className="w-100 theme-blue"
                        disabled={isSubmitting}
                      >
                        Login
                      </Button>
                      <Row className="align-items-center">
                        <Col xs={12} className="text-center pt-2">
                          Don't have an account?{" "}
                          <Link to="/signup">Sign Up</Link>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Login;
